import React from 'react'
import _ from 'lodash'
import * as styles from './styles'
import { DividerHeader, MinimalTable } from '../../styles/utils'
import { ensureWithoutTrailingDot } from '../../util'

export default ({ responses, operationMetadata }) => {

  return (
    <styles.Container>
      <DividerHeader>Successful responses</DividerHeader>

      <MinimalTable>
        <thead>
          <tr>
            <th>Response</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          { _.map(responses, (response, i) => {
            return (
              <tr key={i}>
                <td>
                  <b>
                    {response.statusText}
                  </b>
                </td>
                <td>
                  <a href={`#${operationMetadata.id}-${response.statusCode}-response`}>
                    object
                  </a>
                </td>
                <td>{ensureWithoutTrailingDot(response.description)}</td>
              </tr>
            )
          })}
        </tbody>
      </MinimalTable>
    </styles.Container>
  )
}